import React, { useState } from "react";

import { Example, Compare } from "../../example";
import { MessageInput } from "./component";

export default function MessageInputExample() {
  return (
    <Example
      title="Message input"
      desc={
        <>
          <p>Colorize important parts of input. Everything remains editable.</p>
        </>
      }
      filepath="/src/examples/MessageInput/component.js"
      demo={Demo}
    />
  );
}

function Demo() {
  const [value, setValue] = useState("Hey, @alice! Let's start #challenge");

  return (
    <Compare>
      <Compare.Group title={<code>{"<input>"}</code>}>
        <label style={{ width: "100%" }}>
          <span className="exampleBlock-label">Message</span>
          <input
            className="regularInput"
            value={value}
            onChange={e => {
              setValue(e.target.value);
            }}
          />
        </label>
      </Compare.Group>
      <Compare.Group title={<code>{"<MightyInput>"}</code>}>
        <label style={{ width: "100%" }}>
          <span className="exampleBlock-label">Message</span>
          <MessageInput value={value} onUpdate={next => setValue(next)} />
        </label>
      </Compare.Group>
    </Compare>
  );
}
